import { IScores, setScores } from '@/context/borrower';
import { setAndSortLenders } from '@/context/lender';
import { store } from '@/context/store';
import { getCommissionAmount } from '@/utils/getCommissionAmount';
import { isDemoMode } from '@/utils/setDemoMode';

import { postUrl } from '../fetch';

import {
    EPreApprovalVerdicts,
    IPreApprovalResponse,
} from './fetchPreapprovalVerdict.types';

export async function fetchPreapprovalVerdict(
    creditScoreTestDrive?: boolean,
    isTestDrive?: boolean
): Promise<IPreApprovalResponse> {
    // ***** Send the Request *****
    const url = '/api/submit/preApproval';

    const state = store.getState();
    const customerName = state.borrowerReducer.personalDetails.firstName;
    const applicationId = state.borrowerReducer.application.applicationId;
    // Get Pre Approval parameters
    const lowestMonthlyRepayment =
        state.lenderReducer.lenders?.[0]?.monthlyRepaymentAmount; // TODO: filter to actually get the lowest one

    const sendLeadEmail = state.displayReducer.sendLeadEmail;

    let waterfallLenders: string[][] | undefined = undefined;
    if (state.displayReducer.waterfallLenders) {
        waterfallLenders = [];
        for (let i = 0; i < state.displayReducer.waterfallLenders.length; i++) {
            waterfallLenders.push(
                state.displayReducer.waterfallLenders[i].lenders
            );
        }
    }
    const isDemo = isDemoMode();

    // Get partner commission amount
    const commissionAmount = getCommissionAmount();

    const response = await postUrl<IPreApprovalResponse>(url, {
        monthlyRepayment: lowestMonthlyRepayment,
        waterfallLenders,
        sendLeadEmail,
        commissionAmount,
        isDemoMode: isDemo,
        creditScoreTestDrive: creditScoreTestDrive,
    });

    if (response.verdict === EPreApprovalVerdicts.REFERRED && isTestDrive) {
        const body = {
            phoneNumber: state.borrowerReducer.application.DIFBrokerPhoneNumber,
            message: `Your Customer ${customerName} with application id ${applicationId} is reffered due to low credit score.`,
            partnerId: state.displayReducer.partner.id,
        };
        postUrl('/api/sendCustomMessage', body);
    }
    if (response.verdict === EPreApprovalVerdicts.APPROVED && isTestDrive) {
        const body = {
            phoneNumber: state.borrowerReducer.application.DIFBrokerPhoneNumber,
            message: `Your Customer ${customerName} with application id ${applicationId} is preapproved.`,
            partnerId: state.displayReducer.partner.id,
        };
        postUrl('/api/sendCustomMessage', body);
    }

    // ***** Dispatch response to state *****
    const stateScores = state.borrowerReducer.scores;

    // response returns number | null but FE saves number | undefined
    const scores: IScores = {
        onePointOneScore: response.onePointOneScore
            ? response.onePointOneScore
            : undefined,
        comprehensiveScore: response.comprehensiveScore
            ? response.comprehensiveScore
            : undefined,
        creditScore: response.creditScore ? response.creditScore : undefined,
        creditScorePercentage: response.creditScorePercentage,
        eligibilityScorePercentage: response.eligibilityScorePercentage,
        accuracyScorePercentage: response.accuracyScorePercentage,
    };

    // set scores to state
    store.dispatch(
        setScores({
            ...stateScores, // other scores that aren't returned by this API
            ...scores,
        })
    );

    // Set approved lenders to state
    store.dispatch(setAndSortLenders(response.approvedLenders));

    return response;
}
